import React from 'react';
import { Box, Typography } from '@mui/material';

import { MODULE_BREADCRUMB_NAME } from '../../utils/pageBreadcrumb';

interface AppBreadcrumbProps {
  pageTitle: string;
}

/**
 * Breadcrumb do header — padrão PV/PA: «Módulo / Tela» (first-level / second-level).
 */
export function AppBreadcrumb({ pageTitle }: AppBreadcrumbProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        minWidth: 0,
        color: '#fff',
      }}
    >
      <Typography
        component="span"
        noWrap
        sx={{
          fontSize: { xs: 18, md: 26 },
          fontWeight: 700,
          lineHeight: 1.1,
          letterSpacing: 0,
        }}
      >
        {MODULE_BREADCRUMB_NAME}
      </Typography>
      <Typography
        component="span"
        sx={{
          fontSize: { xs: 18, md: 26 },
          fontWeight: 700,
          lineHeight: 1.1,
        }}
      >
        /
      </Typography>
      <Typography
        component="span"
        noWrap
        sx={{
          fontSize: { xs: 14, md: 19 },
          fontWeight: 700,
          lineHeight: 1.1,
          letterSpacing: 0,
        }}
      >
        {pageTitle}
      </Typography>
    </Box>
  );
}
